import TPremiaCard from "@/components/t-premia-card/t-premia-card";
import React, { useEffect, useRef, useState } from "react";
import { ContentObjectiveStyled, ContentTitleStyled } from "./style-components";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTheme } from "@/contexts/theme-context/useThemeContext";
import { ObjectiveContestProps } from "./objective-contest-type";
import TableContest from "@/components/table-contest/table-contest";
import { useUserContext } from "@/contexts/user/useUserContext";
import useFetch from "@/hook/useFetch/useFetch";
import { getInfoObjectiveRank } from "@/services/mission/missions";
import CountDownUpgradable from "@/components/countdown-upgradable/countdown-upgradable";
import { ParticipantTableType, TableContestProps } from "@/components/table-contest/table-contest-type";
import { SpaceshipLoader } from "@/components/spaceship-loader/spaceship-loader";
import { LoaderContainer } from "@/pages/logged-page/style-component";
import DOMPurify from 'dompurify';

const ObjectiveContest: React.FC<ObjectiveContestProps> = ({
    objective, 
    campaignId, 
    missionId, 
    participant, 
    getProgress, 
    isExpiredMission, 
    isComingSoon,
    isCompleted, 
    completedRequirements, 
    position, 
    setWinners
}) => {
    const temp = false;
    if(temp){
        console.log(campaignId, missionId, participant, completedRequirements);
    }

    const { user, isConnect } = useUserContext();
    const { description } = objective;
    const theme = useTheme();
    const params = useRef({
        objective_id: objective.id,
        ...(user?.main_key && { user_main_key: user?.main_key }),
        limit: 15,
        page: 0,
        order: 'id'
    })
    const { data: participantRank, loading, startFetch: progressRank } = useFetch(getInfoObjectiveRank, params.current, { autoFetch: !isComingSoon});
    const [participantRankState, setParticipantRankState] = useState<TableContestProps['items']>(participantRank)

    const firstRenderReconnect = useRef<boolean>(true);
	useEffect(()=> {
		if(isConnect && user?.main_key && firstRenderReconnect.current) {
            params.current = {
                ...params.current,
                user_main_key: user?.main_key,
            }
			progressRank();
		}
	},[isConnect, progressRank, user?.main_key])

    useEffect(()=>{
        if (participantRank?.length > 0){
            const order = participantRank.sort((a:ParticipantTableType, b:ParticipantTableType) => {
                const pointDifference = b.current_points - a.current_points;
                if (pointDifference !== 0) {
                    return pointDifference;
                }
        
                const isCurrentUserA = String(a.user_main_key).toUpperCase() === String(user?.main_key).toUpperCase();
                const isCurrentUserB = String(b.user_main_key).toUpperCase() === String(user?.main_key).toUpperCase();
        
                if (isCurrentUserA && !isCurrentUserB) return -1;
                if (!isCurrentUserA && isCurrentUserB) return 1;
                return 0;
            });
            setWinners?.([{
                main_key: user?.main_key ?? '',
                isWinner: order?.[0]?.user_main_key === user?.main_key
            }])
            setParticipantRankState(participantRank);
        }
    },[participantRank, setWinners, user?.main_key])
    

    return (
    <TPremiaCard variant="dark" style={{ gap: '0px', padding: '0px', margin: '0px' }}>
        {loading && participantRankState?.length === 0 ?
            <LoaderContainer>
				<SpaceshipLoader height="150px" />
			</LoaderContainer>
        :
        <ContentObjectiveStyled>
            <ContentTitleStyled>
                <p style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`<span class='number'>${position}.</span> ${description}`) }} />
                <InfoCircleOutlined style={{ color: theme.theme.colors.theme.brandColor3 }} />
            </ContentTitleStyled>
            <TableContest 
                items={participantRankState}
                userConnected={user?.main_key ?? ''}
            />
            {!isExpiredMission && !isCompleted && <CountDownUpgradable
                key={`${position}`}
                text={'Siguiente actualizacion'}
                show={true}
                onExecute={async ()=>{
                    await getProgress();
                    await progressRank();
                }}
            />}
        </ContentObjectiveStyled>}
    </TPremiaCard>
    )
}

export default ObjectiveContest;